<template>
  <div class="template_pop" v-if="confirmBuy.show">
    <div>
      <div class="el-icon-close" @click="close" />
      <div class="template_pop_title">购买确认</div>
      <div class="business_info">
        <div v-html="confirmBuy.params.tips" class="template_pop_content" />
      </div>
      <!-- ---------------------- -->
      <div class="payType" v-if="accountInfo.isCustomerMember">
        <el-radio v-model="payType" @change="payTypeChange" :label="0"
          >个人账户支付</el-radio
        >
        <el-radio v-model="payType" @change="payTypeChange" :label="1"
          >公司账户支付</el-radio
        >
      </div>
      <div v-if="payType == 0" class="customerTem">
        <div class="business_info">
          <div>
            账户余额:
            <span>{{ $amountFormat(params.pay_userAmount) }}</span> 元
          </div>
          <div>
            账户积分: <span>{{ $amountFormat(params.pay_userPoint) }}</span>
          </div>
        </div>
        <div class="business_info">
          <div>
            使用积分:
            <el-input-number
              v-model="pointNum"
              :controls="false"
              :precision="2"
              placeholder="请输入使用积分"
              :min="0"
              :max="
                confirmBuy.params.pay_userPoint < confirmBuy.params.expendAmount
                  ? confirmBuy.params.pay_userPoint
                  : confirmBuy.params.expendAmount
              "
              size="small"
              @blur="pointChange"
            />
          </div>
        </div>
        <div class="configTips" v-if="isPay">
          余额不足请充值!最少充值金额1000元！
        </div>
      </div>
      <!-- ---------------------- -->
      <div v-if="payType == 1" class="customerTem">
        <div class="customerBox1">{{ accountInfo.customerName }}</div>
        <div class="customerBox2">
          公司账户余额: <span>{{ accountInfo.customerAmount }}</span> 元
        </div>
      </div>
      <div class="template_pop_btn">
        <el-button
          type="warning"
          size="small"
          @click="submit(true)"
          v-if="isPay && payType == 0"
          >充值购买</el-button
        >
        <el-button
          type="info"
          size="small"
          v-if="isPay && payType == 1"
          disabled
          >余额不足</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="submit(false)"
          v-if="!isPay"
          >确认购买</el-button
        >
        <el-button type="primary" size="small" @click="close" plain
          >取消</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      params: {},
      pointNum: 0,
      amountNum: 0,
      maxPoint: undefined,
      isPay: false,
      payType: 0,
      interval: true,
    }
  },
  methods: {
    payTypeChange(val) {
      this.payType = val
      if (val == 0) {
        this.showInfo()
      } else {
        this.customerPay()
      }
    },
    //公司扣款
    customerPay() {
      if (this.accountInfo.customerAmount >= this.amountNum) {
        this.isPay = false
      } else {
        this.isPay = true
      }
    },
    // 个人扣款
    showInfo(point = undefined) {
      // 设置积分最大使用值
      if (!point) {
        this.params = this.confirmBuy.params
        this.params.pay_userAmount = this.accountInfo.userAmonut
        this.params.pay_userPoint = this.accountInfo.userPoints
        if (this.params.pay_userPoint) {
          if (this.params.expendAmount < this.params.pay_userPoint) {
            this.maxPoint = this.params.expendAmount
            this.pointNum = this.params.expendAmount
            this.amountNum = this.$amountFormat(
              this.params.expendAmount - this.params.pay_userPoint
            )
          } else {
            this.maxPoint = this.params.pay_userPoint
            this.pointNum = this.params.pay_userPoint
            this.amountNum = 0
          }
        } else {
          this.maxPoint = 0
          this.pointNum = 0
          this.amountNum = this.params.expendAmount
        }
      }
      // 扣款 = 消费 - 积分
      if (this.params.expendAmount - this.pointNum > 0) {
        this.amountNum = this.$amountFormat(
          this.params.expendAmount - this.pointNum
        )
      } else {
        this.amountNum = 0
      }
      // 余额 >= 扣款
      if (this.params.pay_userAmount >= this.amountNum) {
        this.isPay = false
      } else {
        this.isPay = true
      }
    },
    pointChange(val) {
      if (this.pointNum == undefined) {
        this.pointNum = 0
      }
      this.showInfo(val)
    },
    submit(ispay) {
      if(!this.interval){
        return
      }
      this.interval = false
      setTimeout(() => {
        this.interval = true
      }, 3000)
      let isVip = this.params.orderdesc == '购买会员'
      if (ispay) {
        // 充值
        if (isVip) {
          this.$pay({
            amount: 100000,
            openid: this.accountInfo.openid,
            description: '充值',
            rechargeCategory: 1,
            membershipLevelId: this.params.memberShipLevelId,
            rechargePurchasePointTotal: this.pointNum,
          })
        } else {
          this.$pay({
            amount: 100000,
            openid: this.accountInfo.openid,
            description: '充值',
            rechargeCategory: 1,
            rechargePurchasePointTotal: this.pointNum,
            rechargePurchaseAcceptNum: this.params.acceptNum,
            rechargePurchaseInqueyId: this.params.inquiryId,
            rechargePurchaseTotal: this.params.expendAmount,
          })
        }
      } else {
        // 公司支付
        if (this.payType == 1) {
          this.$addpurchaserecord({
            inquiryId: this.params.inquiryId,
            expendAmount: this.$amountFormat(this.params.expendAmount),
            acceptNum: this.params.acceptNum,
            rechargeCategory: 1,
            orderdesc: this.params.orderdesc,
            openid: this.accountInfo.openid,
            rechargePurchasePointTotal: 0,
            // 新增
            CustomerNumber: this.accountInfo.customerNumber,
            PayType: this.payType,
            CustomerName: this.accountInfo.customerName,
            success: this.params.success,
          })
          return
        }
        // 购买 个人支付
        if (isVip) {
          this.$addpurchaserecord({
            openid: this.accountInfo.openid,
            expendAmount: this.amountNum,
            acceptNum: this.params.acceptNum,
            rechargeCategory: 1,
            orderdesc: this.params.orderdesc,
            memberShipLevelId: this.params.memberShipLevelId,
            rechargePurchasePointTotal: this.pointNum,
            success: this.params.success,
            PayType: this.payType,
          })
        } else {
          this.$addpurchaserecord({
            inquiryId: this.params.inquiryId,
            expendAmount: this.amountNum,
            acceptNum: this.params.acceptNum,
            rechargeCategory: 1,
            orderdesc: this.params.orderdesc,
            openid: this.accountInfo.openid,
            rechargePurchasePointTotal: this.pointNum,
            success: this.params.success,
            PayType: this.payType,
          })
        }
      }
    },
    close() {
      this.payType = 0
      this.$store.commit('confirmBuy', {
        show: false,
        tips: '',
        callback: undefined,
      })
    },
  },
  watch: {
    confirmBuy: {
      handler(newVal, oldVal) {
        if (newVal.show) {
          this.showInfo()
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(['confirmBuy']),
    ...mapState(['accountInfo']),
  },
}
</script>
<style lang="scss" scoped>
.template_pop_content {
  margin: 20px 0 10px 0px;
  font-weight: 600;
  font-size: 14px;
}
.business_info {
  align-items: center;
}
.configTips {
  font-size: 12px;
  font-weight: 600;
  color: var(--color_del);
  margin: 5px 0;
}
.customerTem {
  height: 80px;
  .business_info,
  .customerBox1 {
    margin-bottom: 10px;
  }
}
// -----
.payType {
  margin-bottom: 25px;
}
.customerBox1 {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}
.customerBox2 {
  color: #000;
  font-weight: 600;
  font-size: 12px;

  span {
    color: var(--color_basic);
  }
}
</style>
